import {
  FETCH_YADS_TENANT_SCENARIOS_REQUEST,
  FETCH_YADS_TENANT_SCENARIOS_SUCCESS,
  FETCH_YADS_TENANT_SCENARIOS_FAILURE
} from '../../../Constants/actionTypes';

import { fetchYadsTenantScenarioGroups } from '../../../Constants/apiService';

export const getTenantScenariosRequest = () => ({ type: FETCH_YADS_TENANT_SCENARIOS_REQUEST });
export const getTenantScenariosSuccess = (data) => ({ type: FETCH_YADS_TENANT_SCENARIOS_SUCCESS, payload: data });
export const getTenantScenariosFailure = (error) => ({ type: FETCH_YADS_TENANT_SCENARIOS_FAILURE, payload: error });

export const getTenantScenarios = () => {
  return async (dispatch, getState) => {
    dispatch(getTenantScenariosRequest());

    const accessToken = getState().auth.accessToken;

    try {
      const data = await fetchYadsTenantScenarioGroups(accessToken);

      const transformedScenarioGroups = data.scenarioGroups.map((group, groupIndex) => ({
        id: `group-${groupIndex + 1}`,
        title: group.title,
        description: group.description,
        supportsHealthIndicator: group.supportsHealthIndicator === true,
        scenarios: group.scenarios.map((scenario, scenarioIndex) => ({
          id: `scenario-${groupIndex + 1}-${scenarioIndex + 1}`,
          title: scenario.title,
          description: scenario.description,
          runMode: scenario.runMode ?? null,
          count: scenario.count ?? 1,
          durationHours: scenario.durationHours ?? null,
          order: scenarioIndex + 1,
          estimatedTime: scenario.estimatedTime,
        })),
      }));

      const tenantOptions = data.tenantDetails || [];

      dispatch(getTenantScenariosSuccess({
        tenantOptions,
        scenarioGroups: transformedScenarioGroups,
      }));
    } catch (error) {
      const errorMsg = error.message?.includes("fetch") ? "Unable to fetch data from server." : error.message;
      dispatch(getTenantScenariosFailure(errorMsg));
    }
  };
};
